import { h,Fragment } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import he from 'he';
import { createClassName, memo } from '../../helpers';
import renderEmojis from './emoji';
import { renderMarkdown } from './markdown';
import styles from './styles.scss';
import MarkdownIt from 'markdown-it';
import DOMPurify from 'dompurify';
import store from '../../../store';
const AsyncTextLoader = ({ fetchText }) => {
  const [text, setText] = useState('');

  useEffect(() => {
    const loadContent = async () => {
      const result = await fetchText();
      setText(result);
    };
    loadContent();
  }, [fetchText]);

  return (
    <>
      {text.split('\n').map((line, index) => (
        <p key={index} dangerouslySetInnerHTML={{ __html: line }}/>
      ))}
    </>
  );
};

// MessageText Component
export const MessageText = memo(({ text, system, className, style = {} }) => {
  const md = new MarkdownIt({
		html: false,
		breaks: true,
		linkify: true,
		typographer: true,
	});
  const preprocessText = (text) => {
		const paragraphs = text.split(/\n{2,}/);    
			const newlineBreaks = text.match(/\n{2,}/g) || [];
			let result = [];

			paragraphs.forEach((paragraph, index) => {
				const lines = paragraph.split('\n');
				lines.forEach(line => {
				result.push(`<p>${line}</p>`);
			});
			
			if (index < newlineBreaks.length) {
			
				const brCount = newlineBreaks[index].length - 1;
				result.push(''.repeat(brCount));
			}
		});

		return result.join('');
	}
  const fetchText = async () => {
    const emojiText = renderEmojis(text);
    const decodedText = he.decode(emojiText);
    text = store.state.sanitazedInput == true?DOMPurify.sanitize(text):text;
    return md.renderInline(text);
  };

  return (
    <div
      className={createClassName(styles, 'message-text', { system }, [className])}
      style={style}>
      <AsyncTextLoader fetchText={fetchText} />
    </div>
  );
});